const { displayMessage } = require("../services/helper");

module.exports = {
    MONITORY_ROOM: { label: displayMessage('MONITORY_ROOM'), value: 1 },
    EXERCISE_ROOM: { label: displayMessage('EXERCISE_ROOM'), value: 2 },
}